<div id="chartdiv_metric_{{metricIndex}}" style="width: 100%; height: 110px">

</div>
